import { useState, useEffect } from 'react';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent;
    const isAndroid = /Android/i.test(userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    const isOtherMobile = /Mobi/i.test(userAgent);
    const windowWidth = window.innerWidth;

    const isMobileDevice = (isAndroid || isIOS || isOtherMobile) && windowWidth <= 768;

    setIsMobile(isMobileDevice);
  }, []);

  return isMobile;
};

export default useIsMobile;